<template>
  <v-app id="app" :dark="isDark">
    <v-content id="all-website-content">
      <authentication v-if="!this.$store.state.signedIn&&this.$route.fullPath!='/privNotice'"></authentication>
      <div v-if="this.$store.state.signedIn||this.$route.fullPath=='/privNotice'">
        <template>
          <v-toolbar :color="bannercolour" dark id="toolbar-title-icons">
            <v-btn color="primary" flat v-on="on" to="/">
              <div><img src="logo.png" />
              <span style="color:white">{{envname}}</span>
              </div>
            </v-btn>
            <template v-if="maintenance">
              SITE CURRENTLY UNDERGOING MAINTENANCE
              <v-spacer></v-spacer>
              <v-tooltip color="primary" bottom id="exit-app" v-if="this.$store.state.signedIn">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon @click="signOut()" :style="$store.state.textFormatting.main">
                    <v-icon>exit_to_app</v-icon>
                  </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Sign Out</span>
              </v-tooltip>

            </template>
            <template v-if="!maintenance">
              <v-toolbar-title v-if="pageTitle">
                {{pageTitle}}
                <template slot>What can {{pageTitle}} do?</template>
                <template slot="body">{{pageMessage}}</template>
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <div v-if="this.$store.state.signedIn">
                <v-tooltip color="primary" bottom id="home" dark>
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat v-on="on" to="/">
                      <v-icon>home</v-icon>
                    </v-btn>
                  </template>
                  <span :style="$store.state.textFormatting.main">Homepage</span>
                </v-tooltip>
              </div>

              <fullnav pagetype="alert" v-if="this.$store.state.signedIn"></fullnav>

              <div v-if="this.$store.state.signedIn">
                <v-tooltip color="primary" bottom id="exec" dark>
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat v-on="on" to="/pollAPI">
                      <v-icon>call</v-icon>
                    </v-btn>
                  </template>
                  <span :style="$store.state.textFormatting.main">Polling API</span>
                </v-tooltip>
              </div>

              <div v-if="this.$store.state.signedIn">
                <v-tooltip color="primary" bottom id="exec" dark>
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat v-on="on" to="/dummyData">
                      <v-icon>merge_type</v-icon>
                    </v-btn>
                  </template>
                  <span :style="$store.state.textFormatting.main">Dummy Data Injection</span>
                </v-tooltip>
              </div>

              <!-- <fullnav pagetype="home" v-if="this.$store.state.signedIn" ></fullnav>
              <fullnav pagetype="alert" v-if="this.$store.state.signedIn"></fullnav> !-->
              <fullnav pagetype="chart" v-if="this.$store.state.signedIn"></fullnav>
              <fullnav pagetype="user" v-if="this.$store.state.signedIn"></fullnav>
              <fullnav pagetype="system" v-if="this.$store.state.signedIn"></fullnav>

              <v-tooltip color="primary" bottom id="feedback" v-if="this.$store.state.signedIn">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <feedback></feedback>
                  </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Feedback/ Bug Report</span>
              </v-tooltip>

              <div v-if="this.$store.state.signedIn">
                <v-tooltip color="primary" bottom id="home" dark>
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat v-on="on" to="/analytics">
                      <h1>A</h1>
                    </v-btn>
                  </template>
                  <span :style="$store.state.textFormatting.main">Analytics Info.</span>
                </v-tooltip>
              </div>
              
              <v-tooltip color="primary" bottom id="home" dark v-if="this.$store.state.signedIn">
                <template v-slot:activator="{ on }" v-if="this.$store.state.signedIn">
                  <v-btn icon flat v-on="on" to="/changelog">
                    <v-icon>menu</v-icon>
                  </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Changelog</span>
              </v-tooltip>

              <v-tooltip color="primary" bottom id="exit-app" v-if="this.$store.state.signedIn">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon @click="signOut()" :style="$store.state.textFormatting.main">
                    <v-icon>exit_to_app</v-icon>
                  </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Sign Out</span>
              </v-tooltip>

              <v-btn icon id="project-overview-info">
                <info>
                  <template slot>Project Overview</template>
                  <template slot="body">
                    <projectOverview></projectOverview>
                  </template>
                </info>
              </v-btn>

              <v-tooltip color="primary" bottom id="exit-app">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    depressed
                    id="change-theme"
                    :style="$store.state.textFormatting.main"
                  >
                    <v-switch v-model="isDark"></v-switch>
                  </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Dark Mode</span>
              </v-tooltip>
            </template>
          </v-toolbar>
        </template>
        <template v-if="!maintenance">
          <homepage v-if="homepage"></homepage>
          <main v-if="!homepage">
            <router-view></router-view>
          </main>
        </template>
        <template v-if="maintenance">
          <maintenancepage></maintenancepage>
        </template>
      </div>
    </v-content>
    <v-layout justify-center align-center>
      <div class="text-xs-center" id="glossary-of-terms">
        <v-bottom-sheet inset hide-overlay>
          <template v-slot:activator>
            <v-btn color="primary" dark :style="$store.state.textFormatting.main">Glossary of terms</v-btn>
          </template>
          <glossaryOfTerms></glossaryOfTerms>
        </v-bottom-sheet>
      </div>
      <div v-if="this.$route.fullPath!='/privNotice'">
        <v-btn
          to="/privNotice"
          color="primary"
          dark
          :style="$store.state.textFormatting.main"
        >Privacy Notice / Cookie Policy</v-btn>
      </div>
      <div v-if="this.$route.fullPath!='/faq'">
        <v-btn
          to="/faq"
          color="primary"
          dark
          :style="$store.state.textFormatting.main"
        >FAQ</v-btn>
      </div>
    </v-layout>
  </v-app>
</template>

<script>
import { Auth } from "aws-amplify";
import { API, graphqlOperation } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import homepage from "./components/functionality/HomePage.vue";
import authentication from "./shared/operational/authentication.vue";
import info from "./shared/operational/infopopout_under.vue";
import fullnav from "./shared/operational/full-navigation.vue";
import glossaryOfTerms from "./shared/operational/glossary-of-terms.vue";
import projectOverview from "./shared/developing/project-overview.vue";
import { pageInformation } from "./shared/operational/infopopout.js";
import feedback from "./shared/operational/feedback-window.vue";
import maintenancepage from "./components/functionality/MaintenancePage.vue";

export default {
  // inject: ['theme'],
  name: "app",
  components: {
    homepage,
    info,
    authentication,
    fullnav,
    glossaryOfTerms,
    projectOverview,
    feedback,
    maintenancepage
  },
  data() {
    return {
      on:{},
      maintenance:false,
      isDark: this.$store.state.darkMode,
      currentRoute: null,
      homepage: false,
      user: "",
      siStatus: false,
      userASNs: [],
      ASNS: null,
      asnInvTypes: {
        0: "Regular",
        1: "High Importance",
        2: "Low Importance",
        3: "Muted",
        4: "Show All"
      },
      showFeedback: false,
      window: {
        height: 0,
        width: 0
      },
      pageTitle: null,
      pageMessage: null,
      envname: "",
      bannercolour: "primary"
    };
  },
  errorCaptured() {
    const v = this;
    console.log("IN ERROR CATCHER");
    try {
      Auth.currentAuthenticatedUser()
        .then(result => {
          //console.log(result)
          if (!result) {
            console.log("signing out");
            v.$store.commit("signOut");
          }
        })
        .catch(err => {
          console.log(err);
          console.log("signing out");
          v.$store.commit("signOut");
        });
    } catch (err) {
      console.log(err);
      console.log("signing out");
      v.$store.commit("signOut");
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    const vm = this;
    this.envname=process.env.VUE_APP_DEPLOYED;
    if (process.env.VUE_APP_DEPLOYED=="DEV") {
      this.envname="DEV";
      this.bannercolour="dev";
    }
    AmplifyEventBus.$on("authState", info => {
      //New Log in
      if (info === "signedIn") {
        vm.$store.state.signedIn = true;
        vm.siStatus = true;
        vm.signInSuccess();
      } else {
        vm.$store.commit("signOut");
      }
    });
    vm.signInSuccess(); //Welcome Back Login
    try {
      vm.isDark = vm.$store.state.darkMode;
      //console.log("this is dark: " + vm.isDark);
      //console.log("stored darkmode: " + vm.$store.state.darkMode);
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    getMOTDstatus: async function () {
      try {
        this.maintenance=false;
        var query = `query getMOTD { getMOTD { message, msgtext } }`;
        const motd = await API.graphql(graphqlOperation(query));
        //console.log(motd.data.getMOTD.message)
        if (motd.data.getMOTD.message=="maintenance") {
          this.maintenance=true;
        }

      } catch (err) {
        console.log(err);
      }
    },
    checkSignedIn() {
      //console.log("Checking Maint")
      this.getMOTDstatus()
      const v = this;
      //console.log("Checking signed in status...");
      try {
        Auth.currentSession()
          .then((session) => {
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            //console.log("got session")
            if (idTokenExpire < currentTimeSeconds) {
              Auth.currentAuthenticatedUser()
                .then((res) => {
                  res.refreshSession(refreshToken, (err) => {
                    if (err) {
                      Auth.signOut()
                      //console.log(err);
                      //console.log("signing out 1");
                      v.$store.commit("signOut");
                    } else {
                      //console.log("user is signed in still - refreshed")
//                      config.headers.Authorization = "Bearer " + data.getIdToken().getJwtToken();
//                      resolve(config);
                    }
                  });
                });
            } else {
//              config.headers.Authorization = "Bearer " + session.getIdToken().getJwtToken();
//              resolve(config);
                console.log("user is signed in still - no refresh required")

            }
          })
          .catch(err => {
            // No logged-in user: don't set auth header
            console.log(err);
            console.log("signing out 2");
            v.$store.commit("signOut");
//            resolve(config);
          });      
      } catch (err) {
        console.log(err);
        console.log("signing out 3");
        v.$store.commit("signOut");
      }
    },
    checkSignedInOld() {
      //console.log("Checking Maint")
      this.getMOTDstatus()
      const v = this;
      //console.log("Checking signed in status...");
      try {
        Auth.currentAuthenticatedUser()
          .then(result => {
            //console.log(result)
            if (!result) {
              console.log("signing out");
              v.$store.commit("signOut");
              v.$forceUpdate();
              }
          })
          .catch(err => {
            console.log(err);
            console.log("signing out");
            v.$store.commit("signOut");
          });
      } catch (err) {
        console.log(err);
        console.log("signing out");
        v.$store.commit("signOut");
      }
    },
    setDM: async function() {
      //console.log("SETTING DARKMODE");
      this.$store.commit("setDarkMode", this.isDark);
      //console.log("stored darkmode: " + this.$store.state.darkMode);
    },
    signInSuccess: async function() {
      try {
        const signedin = await Auth.currentAuthenticatedUser(); //this is a call to the amplify API to get the credentials of the user
        if (signedin.username != undefined) {
          this.siStatus = true; //siStatus is a local version of the current Signin status
          var userDetailsFormatted = this.formatUserData(signedin); // This function finds the username of the person who is signed in - this should match the username which they put in
          this.user = userDetailsFormatted.username;
          this.$store.state.signedIn = true; //global store for the state of signed in (this means an API request doesnt need to be sent everytime we check)
          this.$store.state.user = userDetailsFormatted;
          this.alertsPerASNandInfo();
          this.systemStatsDashboardDownload();
          //this.top10Alerts()

          if (this.$route.fullPath == "/") {
            //So following the checks to see if user is signed in, check the path and if its the '/' (HOME) path then show the homepage.
            this.currentRoute = this.$route.fullPath;
            this.homepage = true; // Home page is technically an add-on to the 'APP' page therefore if homepage is true it will be shown.
          } else {
            this.homepage = false;
          }
        } else {
          this.siStatus = false;
          this.homepage = false;
          this.$store.commit("signOut");
        }
      } catch (err) {
        console.log(err)
        this.siStatus = false;
        this.homepage = false;
        this.$store.commit("signOut");
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width > 1920) {
        this.$store.commit("setTextFormatting", {
          headers: {
            fontSize:
              (20 + Math.floor((this.window.width - 1920) / 181)).toString() +
              "px"
          },
          main: {
            fontSize:
              (14 + Math.floor((this.window.width - 1920) / 218)).toString() +
              "px"
          },
          dialog: {
            width: Math.floor(this.window.width / 3),
            b_width: Math.floor(this.window.width / 1.5)
          },
          traceroute: {
            width:
              900 +
              Math.floor((this.window.width - 1920) * (800 / (4096 - 1920))),
            s_height:
              280 +
              Math.floor((this.window.width - 1920) * (120 / (4096 - 1920))),
            a_height:
              500 +
              Math.floor((this.window.width - 1920) * (300 / (4096 - 1920))),
            fontSize:
              12 + Math.floor((this.window.width - 1920) * (8 / (4096 - 1920))),
            s_x:
              0.2 -
              Math.round(
                (this.window.width - 1920) * (0.08 / (4096 - 1920)) * 100
              ) /
                100,
            s_y:
              0.5 -
              Math.round(
                (this.window.width - 1920) * (0.25 / (4096 - 1920)) * 100
              ) /
                100,
            a_x:
              0.15 -
              Math.round(
                (this.window.width - 1920) * (0.07 / (4096 - 1920)) * 100
              ) /
                100,
            a_y:
              0.25 -
              Math.round(
                (this.window.width - 1920) * (0.1 / (4096 - 1920)) * 100
              ) /
                100
          },
          chart: {
            axis_label:
              12 + Math.floor((this.window.width - 1920) * (12 / (4096 - 1920)))
          }
        });
      } else if (this.window.width > 1200) {
        this.$store.commit("setTextFormatting", {
          headers: {},
          main: {},
          dialog: {
            width: Math.floor(this.window.width / 2),
            b_width: Math.floor(this.window.width / 1.2)
          },
          traceroute: {
            width: 900,
            s_height: 280,
            a_height: 500,
            fontSize: 12,
            s_x: 0.2,
            s_y: 0.5,
            a_x: 0.15,
            a_y: 0.25
          },
          chart: {
            axis_label: 12
          }
        });
      } else {
        this.$store.commit("setTextFormatting", {
          headers: {},
          main: {},
          dialog: {
            width: Math.floor(this.window.width / 1.5),
            b_width: Math.floor(this.window.width / 1.2)
          },
          traceroute: {
            width: 900,
            s_height: 280,
            a_height: 500,
            fontSize: 12,
            s_x: 0.2,
            s_y: 0.5,
            a_x: 0.15,
            a_y: 0.25
          },
          chart: {
            axis_label: 12
          }
        });
      }
    },
    formatUserData: function(i) {
      try {
        var userDetails = {
          username: i.username,
          email: i.attributes.email,
          email_verified: i.attributes.email_verified,
          family_name: i.attributes.family_name,
          given_name: i.attributes.given_name,
          organisation: i.attributes.locale,
          user_type: i.attributes.name,
          sub: i.attributes.sub,
          login_time: i.signInUserSession.accessToken.payload.auth_time
        };
        return userDetails;
      } catch (err) {
        // Needs to be some logic here to ensure the user has signed in and maybe redirect to adit there user as the creds arent there.
        this.homepage = false;
        this.$store.state.signedIn = false;
        this.$store.state.user = null;
      }
    },
    alertsPerASNandInfo: async function() {
      var dd = Math.floor(new Date() / 1000 - 86400);
      try {
        var query =
          `query getuserasn { getASNsForOrg( start_time:` +
          dd +
          `)
            { 
                asn 
                notification_count 
                H 
                I 
                V 
                peering_asn 
                type
                path_change_count
                first_seen_count
                ownership_assertion_count
            }
        }`;
        const getASNInfo = await API.graphql(graphqlOperation(query));
        var ASNInformation = getASNInfo.data.getASNsForOrg;
        this.$store.state.allASNInfoForOrg = [];

        var topush = [];
        for (var i = 0; i < ASNInformation.length; i++) {
          if (ASNInformation[i].notification_count == null) {
            ASNInformation[i].notification_count = 0;
          }

          if (ASNInformation[i].type in [0, 1, 2, 3, 4]) {
            ASNInformation[i].type = this.asnInvTypes[ASNInformation[i].type];
          } else {
            ASNInformation[i].type = "Not Defined";
          }
          var reqBreDow = {
            H: ASNInformation[i].H,
            I: ASNInformation[i].I,
            V: ASNInformation[i].V,
            asn: ASNInformation[i].asn,
            count: ASNInformation[i].notification_count,
            peering_asn: ASNInformation[i].peering_asn,
            type: ASNInformation[i].type,
            first_seen: ASNInformation[i].first_seen_count,
            path_change: ASNInformation[i].path_change_count,
            ownership_assertion: ASNInformation[i].ownership_assertion_count
          };
          topush.push(reqBreDow);
        }
        this.$store.state.allASNInfoForOrg = topush;
      } catch (err) {
        console.log(err);
      }
    },
    top10Alerts: async function() {
      // API CAN NOT CURRENTLY SUPPORT THIS
      var query =
        "query top10 { getTop10Alerts { episode_id origin_asn_old origin_asn_new when prefix h i v reason}}";
      const top10data = await API.graphql(graphqlOperation(query));
      var t10 = top10data.data.getTop10Alerts;

      for (var n = 0; n < t10.length; n = n + 1) {
        var d_t = t10[n].when;
        var date = d_t.substr(0, 10);
        var time = d_t.substr(11, 8);
        var datetime = { date: date, time: time };
        t10[n].when = datetime;
      }
      this.$store.state.top10Alerts = t10;
    },
    signOut: async function() {
      // This is associated with the signout button
      this.$Amplify.Auth.signOut()
        .then(() => {
          // this.logger.info('signout success')
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(e => this.setError(e));

      (this.siStatus = false), (this.$store.state.signedIn = false);
    },
    titleNameSelector(route) {
      this.pageMessage = pageInformation[route.fullPath];
      this.pageTitle = route.name;
    },
    systemStatsDashboardDownload: async function() {
      var query = `query getEpisodeStatsAll { getScoredEpisodeStats (interval_length_seconds: 86400,
              interval_count: 7, page_offset: 0, page_rows:86400) {
                    total_episode_count
                    total_event_count
                    hijack_count
                    unique_prefix_count
                    bogon_count
                    route_leak_count
                    path_change_count
                    first_obs_count
                    interval_start
                    } 
      }`;
      API.graphql(graphqlOperation(query))
        .then(data => {
          this.$store.state.systemStats = data.data.getScoredEpisodeStats;
        })
        .catch(err => {
          console.log(err);
        });
      var d = new Date();
      var day = ("0" + d.getUTCDate()).slice(-2);
      var month = ("0" + (d.getUTCMonth() + 1)).slice(-2);
      var year = d.getUTCFullYear();
      var dateFormatted = day + "/" + month + "/" + year;
      var timeFormatted =
        ("0" + d.getUTCHours()).slice(-2) +
        ":" +
        ("0" + d.getUTCMinutes()).slice(-2);
      this.$store.state.systemStatsUpdate =
        "U: " + dateFormatted + " " + timeFormatted;
    }
  },

  watch: {
    $route(to) {
      if (to.fullPath == "/") {
        this.currentRoute = to.fullPath;
        this.pageMessage = pageInformation["/"];
        this.homepage = true;
        this.pageTitle = "Homepage";
      } else {
        this.currentRoute = to.fullPath;
        this.homepage = false;
        this.titleNameSelector(to);
      }
      //console.log("AUTH")
      //console.log($Amplify.Auth)
    },
    isDark(n) {
      this.$store.commit("setDarkMode", n);
    }
  }
};
</script>

<style>
.v-slider__thumb {
  cursor: grabbing;
  height: 30px;
  width: 30px;
}
</style>